import { SubscriptionImport } from './Import'
import { Offcanvas } from 'react-bootstrap'
import { Text } from '../../components/input_fields'
import { ApplyButton, ClearButton } from '../../components/buttons'
import { toggleBool } from '../../redux/slices/globalSlice'

const { useNavigate, useDispatch, paymentList, parseLinkHeader, useTranslation } = SubscriptionImport

export default function PaymentListFilter(props) {

    const { setTableLoading, setPageable, pageable, setHeaderLink, show, onHide } = props
    const { t } = useTranslation()
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const handleClose = () => onHide()

    const apply_filter = () => updatePageable({ search: pageable?.search, currentPage: 0 })

    const clear_filter = () => {
        setPageable({
            'pageSize': 10,
            'currentPage': 0,
            'search': '',
            'totalRecord': 0,
        })
        dispatch(toggleBool())
        onHide()
    }

    const updatePageable = (updates) => {
        onHide()
        setTableLoading(true);

        const newPageable = { ...pageable, ...updates };
        setPageable(newPageable);

        dispatch(paymentList({ pageable: newPageable, navigate })).then((res) => handleResponse(res.payload));
    }

    const handleResponse = (res) => {
        if (res?.status === 200) {
            const parsed = parseLinkHeader(res.headers.link)
            setHeaderLink(parsed)
            setPageable(prev => ({
                ...prev,
                'pageSize': parseInt(res.headers.get('x-page-limit'), 10),
                'currentPage': parseInt(res.headers.get('x-current-page'), 10),
                'totalRecord': parseInt(res.headers.get('x-Total-Count'), 10),
            }))
        }
        setTableLoading(false)
    }

    return (
        <>
            <Offcanvas show={show} onHide={handleClose} placement='end' backdrop="static" >
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>{t('subscription.payment_list') + ' ' + t('subscription.search')}</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>

                    <Text
                        label_name={t('subscription.search')}
                        mandatory={false}
                        placeholder=''
                        disabled={false}
                        name='search'
                        value={pageable?.search}
                        onChange={(e) => setPageable({ ...pageable, "search": e.target.value })}
                    />

                    <div className='d-flex' style={{ position: "absolute", bottom: 10, right: 10 }}>
                        <ApplyButton
                            button_name={t('common.apply') || 'Apply'}
                            onClick={() => apply_filter()}
                        />
                        <ClearButton
                            button_name={t('common.clear') || 'Clear'}
                            onClick={() => clear_filter()}
                        />
                    </div>

                </Offcanvas.Body>
            </Offcanvas>
        </>
    )
}
